/**
 * @param {{ onCancel: () => void; onDone: () => void }} props
 */
function DesignAreaModalActions({ onCancel, onDone }) {
  return (
    <div className="design-area-modal-actions">
      <button type="button" className="design-area-cancel-button" onClick={onCancel}>
        Cancel
      </button>
      <button type="button" className="design-area-done-button btn btn-primary" onClick={onDone}>
        Done
      </button>
    </div>
  );
}

export default DesignAreaModalActions;
